import React, { useRef, useState } from "react";
import { HiSearch } from "react-icons/hi";
import { useQuery } from "react-query";
import { MPaging2 } from "../../components/Common/PagingM";
import {
  Loading,
  SearchArea,
  ThumbnailList,
  ViewHeader,
} from "../../components/DContents/Mobile/MTemplate";
import { NormalReqApi } from "../../utils/ReqApi";
import { Link } from "react-router-dom";
import styled from "styled-components";

const EP = process.env.REACT_APP_AWS_ENDPOINT;
const EventMobile = () => {
  const [page, setPage] = useState(1);
  const [sc, setSc] = useState({
    keyword: "",
    keyType: "title",
  });
  const wordRef = useRef(null);

  const handleSearch = () => {
    const keyword = wordRef.current.value;
    setSc({
      ...sc,
      keyword,
    });
  };
  const handlePage = (page) => {
    setPage(page * 1);
    window.scrollTo(0, 0);
  };

  const { data, error, isLoading } = useQuery(
    ["eventList", page, sc],
    async () =>
      await NormalReqApi(
        "get",
        `/event/list?page=${page}&keyType=${sc.keyType}&keyword=${sc.keyword}`
      ),
    { retry: true }
  );

  return (
    <ViewHeader label={"이벤트"}>
      <Link to={`/eventresult`}>
        <LinkText>이벤트 당첨 확인하기</LinkText>
      </Link>
      <SearchArea>
        <input type="text" className={"dcSearchTitle"} ref={wordRef} />
        <HiSearch color={"white"} onClick={handleSearch} />
      </SearchArea>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <ul>
            {data.data.result.map((item, index) => (
              <ThumbnailList
                key={`dc_list_event_${index}`}
                {...item}
                url={`/event/${item._id}`}
                src={EP + "w_280/" + item.thumbnail.path}
              />
            ))}
          </ul>
          <MPaging2 data={data} curPage={page} toggle={handlePage} />
        </>
      )}
    </ViewHeader>
  );
};

export default EventMobile;

const LinkText = styled.span`
  display: block;
  padding: 0.25em 1em 0.25em 0.25em;
  margin-bottom: 1em;

  color: #fff;
  font-size: 0.55em;
  width: 100%;
  text-align: right;
`;
